import { useContext } from 'react';

import { ReportContext } from './ReportContext';

export const useReportContext = () => {
  return useContext(ReportContext);
};
